"use strict"

function iota(n) {
  var result = new Array(n)
  for(var i=0; i<n; ++i) {
    result[i] = i
  }
  return result
}

module.exports = iota


//////////////////
// WEBPACK FOOTER
// ./~/iota-array/iota.js
// module id = 1786
// module chunks = 0